import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { config } from '@react-spring/web';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Some z-indices to describe layers
 */

var Layers = {
  Popup: 20,
  Alert: 10000
};
/**
 * Some preset springs. See https://react-spring-visualizer.com/ to visualize the effects
 */

var slideAnimationSpringConfig = {
  // to match timing and feel of the Blueprint drawers
  mass: 0.7,
  // default: 1
  tension: 220,
  // default: 170
  friction: 15,
  // default: 26
  clamp: true // default: false

};
var gentleSlideAnimationSpringConfig = _objectSpread(_objectSpread({}, config.gentle), {}, {
  mass: 5,
  tension: 150,
  clamp: true
});

export { Layers, gentleSlideAnimationSpringConfig, slideAnimationSpringConfig };
//# sourceMappingURL=constants.js.map
